import React from 'react';
import { createRoot } from 'react-dom/client';
import './global.css';
import './fonts.css';

export function mount(Page: React.ComponentType) {
  const root = document.getElementById('root');
  if (!root) throw new Error('Missing page root');
  createRoot(root).render(<Page />);
}
